module.exports = __webpack_public_path__ + "img/dash-icon6.ea29f6df.png";